import classNames from 'classnames';

import React, {PropsWithChildren, useRef} from 'react';
import {useResetScrollOnNavigate} from '../../hooks/useResetScrollOnNavigate';

interface Props {
    className?: string;
}

export default function BluemateContent({className, children}: PropsWithChildren<Props>) {
    const pageRef = useRef<HTMLDivElement | null>(null);

    useResetScrollOnNavigate(pageRef);

    return (
        <div ref={pageRef} className={classNames('page', className)}>
            <div className='page-inner'>{children}</div>
        </div>
    );
}
